import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_134_1709)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6708 2.21744L21.1708 6.96744C21.679 7.22153 22 7.74092 22 8.30908V9.75006C22 10.4404 21.4404 11.0001 20.75 11.0001H20V19.0001H21C21.5523 19.0001 22 19.4478 22 20.0001C22 20.5524 21.5523 21.0001 21 21.0001H3C2.44772 21.0001 2 20.5524 2 20.0001C2 19.4478 2.44772 19.0001 3 19.0001H4V11.0001H3.25C2.55964 11.0001 2 10.4404 2 9.75006V8.30908C2 7.78827 2.26974 7.30843 2.70611 7.03636L11.3292 2.21744C11.7515 2.0063 12.2485 2.0063 12.6708 2.21744ZM17 11.0001H7V19.0001H9V13.0001H11V19.0001H13V13.0001H15V19.0001H17V11.0001ZM12 6.00012C11.4477 6.00012 11 6.44784 11 7.00012C11 7.55241 11.4477 8.00012 12 8.00012C12.5523 8.00012 13 7.55241 13 7.00012C13 6.44784 12.5523 6.00012 12 6.00012Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_134_1709",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBankFill;
